



























































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class GameReportBody extends Vue {
  @Prop() readonly data: any;

  @Prop() readonly footer: any;

  @Prop() readonly gameType!: string;

  @Prop() readonly provider!: string;

  @Prop() readonly currentState!: string;

  @Prop() readonly handleSub!: Function;

  utilsInstance = utils;
}
